import { Navigate } from "react-router-dom";
const WhyTPS = () => <Navigate to="/#why-tps" replace />;
export default WhyTPS;
